import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = [
    'password',
    'confirmation',
    'confirmationIndicator',
    'lengthIndicator',
    'numberIndicator',
    'specialIndicator',
    'capitalIndicator',
    'lowercaseIndicator',
  ]

  validate() {
    const value = this.passwordTarget.value

    this.setIndicator(
      this.lengthIndicatorTarget,
      value.length >= 12 && value.length <= 22,
    )
    this.setIndicator(this.numberIndicatorTarget, /\d/.test(value))
    this.setIndicator(this.specialIndicatorTarget, /[^A-Za-z0-9]/.test(value))
    this.setIndicator(this.capitalIndicatorTarget, /[A-Z]/.test(value))
    this.setIndicator(this.lowercaseIndicatorTarget, /[a-z]/.test(value))
    this.setIndicator(
      this.confirmationIndicatorTarget,
      value === this.confirmationTarget.value && value.length > 0,
    )
  }

  toggleVisibility() {
    const nextType =
      this.passwordTarget.type === 'password' ? 'text' : 'password'

    this.passwordTarget.type = nextType
    this.confirmationTarget.type = nextType
  }

  setIndicator(element, valid) {
    element.classList.toggle('bg-green-600', valid)
    element.classList.toggle('bg-orange-500', !valid)
  }
}
